export const PRO_ACCESS = Object.freeze({
  PRO: 'pro',
  FREE: 'free',
  UNKNOWN: 'unknown',
});

const isProStatus = (status) => Boolean(status?.isPro ?? status?.is_pro);

const isUnverifiedStatus = (status) => Boolean(
  status?.verificationFailed ?? status?.verification_failed
);

/**
 * 구독 로딩/검증 실패를 무료 사용자로 오판하지 않도록 서버 상태를 확인한다.
 * 상태를 보관하지 않는 순수 헬퍼라 멀티탭·멀티워커 환경에서도 동일하게 동작한다.
 */
export async function resolveProAccess({
  subscriptionStatus,
  fetchSubscriptionStatus,
  forceRefresh = false,
}) {
  if (
    !forceRefresh
    && subscriptionStatus
    && !isUnverifiedStatus(subscriptionStatus)
  ) {
    return isProStatus(subscriptionStatus) ? PRO_ACCESS.PRO : PRO_ACCESS.FREE;
  }

  try {
    const latestStatus = await fetchSubscriptionStatus(true);
    if (!latestStatus || isUnverifiedStatus(latestStatus)) {
      return PRO_ACCESS.UNKNOWN;
    }
    return isProStatus(latestStatus) ? PRO_ACCESS.PRO : PRO_ACCESS.FREE;
  } catch (_error) {
    return PRO_ACCESS.UNKNOWN;
  }
}
